import { useState } from 'react'
import { useHubStatus } from '../services/hubStatus'
import { triggerProbeNow } from '../services/hubProbe'
import { t } from '../i18n/translations'

/**
 * Hub 接続障害時に画面上部に表示する軽量バナー。
 *
 * - hubStatus が 'offline' の間のみ表示。'unknown' / 'online' では何も描画しない。
 * - 「再接続」ボタン押下で `triggerProbeNow()` を呼び、即時プローブする。
 * - 致命的な認証エラー（再認証要）は別経路（App.tsx の `error-screen`）で
 *   全画面表示するため、本バナーはあくまで「Hub 一時障害」用。
 */
export function OfflineBanner() {
  const status = useHubStatus()
  const [reconnecting, setReconnecting] = useState(false)

  if (status !== 'offline') return null

  const handleReconnect = async () => {
    if (reconnecting) return
    setReconnecting(true)
    try {
      await triggerProbeNow()
    } finally {
      setReconnecting(false)
    }
  }

  return (
    <div className="offline-banner" role="status" aria-live="polite">
      <span className="offline-banner__message">
        {t('offlineMessage')}
      </span>
      <button
        type="button"
        className="offline-banner__retry"
        onClick={() => {
          void handleReconnect()
        }}
        disabled={reconnecting}
      >
        {reconnecting ? t('reconnecting') : t('reconnect')}
      </button>
    </div>
  )
}
